import { Directive, DirectiveBinding } from 'vue';
import { FeatureFlagsService } from '@/services/feature-flags-service';
import { FeatureName } from '@/types/feature-names';

const FeatureEnabledDirective: Directive<HTMLElement, FeatureName> = (
    element: HTMLElement,
    binding: DirectiveBinding<FeatureName>
): void => {
    const isEnabled: boolean = FeatureFlagsService.isFeatureEnabled(binding.value);

    if (isEnabled) {
        return;
    }

    element.remove();
};

export default FeatureEnabledDirective;
